export function LogoMark({ className = "h-9 w-auto" }) {
  return (
    <svg viewBox="0 0 96 64" className={className} role="img" aria-label="JSL Dental Repair logo">
      <rect x="0" y="4" width="28.6" height="56" rx="4" fill="#EA4C89" />
      <rect x="33.7" y="4" width="28.6" height="56" rx="4" fill="#3BBFE6" />
      <rect x="67.4" y="4" width="28.6" height="56" rx="4" fill="#7FC16C" />
      <g fill="#fff">
        <rect x="5" y="18" width="2.6" height="10" rx="1.2" />
        <rect x="9" y="17" width="2.6" height="11" rx="1.2" />
        <rect x="13" y="17" width="2.6" height="11" rx="1.2" />
        <rect x="17" y="18" width="2.6" height="10" rx="1.2" />
        <path d="M6.5 28h13.6a3.2 3.2 0 0 1 0 6.4H9.7A3.4 3.4 0 0 1 6.5 31z" />
        <rect x="7.5" y="34.4" width="11" height="21" rx="4" />
        <path d="M4.5 15.5c2.6-4.4 7.2-5.6 10.5-3.4 3.4-2.6 9.4-1.2 10.2 2.4.7 3-.6 5.4-2.8 6.6H8.3c-2.6-1-4.6-4-3.8-9z" opacity=".95" />
      </g>
      <path
        d="M48 15.5c-3.2 0-4.3 1.8-6.7 1.8s-3.2-1.2-5.3-1c-3.2.5-4.9 3.4-4.4 6.6.5 3.2 2.6 5.9 3.7 9.3 1 3.1 1.3 8.4 3.6 8.6 2.4.2 2-4.9 3.7-7.8.7-1.3 2.9-1.3 3.6 0 1.7 2.9 1.3 8 3.7 7.8 2.3-.2 2.6-5.5 3.6-8.6 1.1-3.4 3.2-6.1 3.7-9.3.5-3.2-1.2-6.1-4.4-6.6-2.1-.3-3.2 1-5.3 1s-3.5-1.8-6.7-1.8z"
        fill="#fff"
        transform="translate(13.8 2) scale(.86)"
      />
      <g fill="#fff">
        <circle cx="81" cy="17" r="6.4" />
        <rect x="79.6" y="23" width="2.8" height="26" rx="1.4" />
        <path d="M92 12.5c2.6 2.6 2.6 6.6.4 9.2" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" />
        <rect x="88.6" y="21" width="2.8" height="28" rx="1.4" />
      </g>
    </svg>
  );
}

export default function Logo({ light = false }) {
  if (light) {
    return (
      <span className="inline-flex items-center gap-3" data-testid="brand-logo">
        <LogoMark className="h-9 w-auto shrink-0" />
        <span className="leading-none">
          <span className="font-display block text-[17px] font-extrabold tracking-tight text-white">
            JSL DENTAL REPAIR
          </span>
          <span className="mt-1 block text-[9px] font-semibold uppercase tracking-[0.18em] text-brandsky">
            Efficient repairs, brilliant smiles
          </span>
        </span>
      </span>
    );
  }

  return (
    <img
      src="/logo.png"
      alt="JSL Dental Repair — Efficient repairs, brilliant smiles"
      className="h-11 w-auto"
      data-testid="brand-logo"
    />
  );
}